import { render, staticRenderFns } from "./TeacherInfo.vue?vue&type=template&id=223ccb71&scoped=true&"
import script from "./TeacherInfo.vue?vue&type=script&lang=js&"
export * from "./TeacherInfo.vue?vue&type=script&lang=js&"
import style0 from "./TeacherInfo.vue?vue&type=style&index=0&id=223ccb71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223ccb71",
  null
  
)

component.options.__file = "TeacherInfo.vue"
export default component.exports